<clkUiElements-icon-button
    [element-id]="elementId()"
    icon-id="arrow_back"
    icon-type="outlined"
    size="small"
    color="neutral"
    (on-click)="onClick()"
/>